import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useLocation } from 'react-router'
import classnames from 'classnames'
import URI from 'urijs'
import bowser from 'bowser'

import {
  VideoPlayerComponent,
  WebinarRoomHeaderComponent,
  WindowTitleComponent,
} from '../../../sharedLegacy/components'
import { WebinarAudienceSidebarFeature } from '../../../sharedLegacy/features'
import { WebinarAudienceMobileSidebarFeature } from '../../../sharedLegacy/features/WebinarAudienceSidebarFeature'
import { initAudienceRoom } from '../../actions'
import { WebinarAudienceWaitingRoomComponent } from '..'
import { useSiteQuery } from '../../../global/blocs/useSite'
import { useLiveDataQuery } from '../../../global/blocs/useLiveData'

import './WebinarAudienceRoomContainerComponent.scss'

const renderContent = (isBroadcasting, liveData) => {
  if (!liveData) {
    return null
  }

  const isOnDemand =
    liveData.enable_ondemand_p && liveData.live_status === 'previous'

  if (!isBroadcasting && !isOnDemand) {
    return <WebinarAudienceWaitingRoomComponent />
  }

  return (
    <VideoPlayerComponent
      object={liveData}
      objectType="live"
      options={{
        autoPlay: 1,
        mutedAutoPlay: 1,
        source: 'site',
        showLogo: 0,
        unmuteButtonPosition: 'center',
        include_actions_p: 0,
      }}
    />
  )
}

const detectMobileDevice = () => {
  const { matches } = window.matchMedia('(max-width: 960px)')

  return matches
}

const WebinarAudienceRoomContainerComponent = (props) => {
  const { isBroadcasting } = props
  const { data: liveData } = useLiveDataQuery()
  const { data: site } = useSiteQuery()

  const location = useLocation()

  const uri = URI(location.search)

  // TODO: this eslint rule disabling should be solved whenever
  // this module is touched again and can be tested

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    props.initAudienceRoom(
      window.LIVE_ID,
      window.LIVE_TOKEN,
      detectMobileDevice(),
      uri.hasQuery('show_thank_you', '1')
    )

    document.body.classList.add('react-audience-room')
  }, [])
  /* eslint-enable react-hooks/exhaustive-deps */

  return (
    <div
      className={classnames('webinar-audience-room-container-component', {
        'has-waiting-room': !isBroadcasting,
      })}
    >
      <WindowTitleComponent
        /* eslint-disable-next-line formatjs/no-literal-string-in-jsx */
        title={`${liveData?.name} - ${site?.site_name}`}
      />
      <div className="webinar-content">
        <div className="webinar-main-content">
          <WebinarRoomHeaderComponent />
          {renderContent(props.isBroadcasting, liveData)}
        </div>
        {liveData && (
          <>
            {!bowser.mobile ? (
              <WebinarAudienceSidebarFeature
                namespace="webinar-audience-sidebar"
                defaultSidebarTab="info"
                role="audience"
                token={liveData.token}
                peopleTabName="Speakers"
                canPostQuestions
              />
            ) : (
              <WebinarAudienceMobileSidebarFeature
                namespace="webinar-audience-sidebar"
                defaultSidebarTab="info"
                role="audience"
                token={liveData.token}
                peopleTabName="Speakers"
                canPostQuestions
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

WebinarAudienceRoomContainerComponent.propTypes = {
  initAudienceRoom: PropTypes.func,
  isBroadcasting: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  location: PropTypes.object,
}

const mapStateToProps = (state) => ({
  isBroadcasting: state.webinarAudienceRoom.isBroadcasting,
})

export default connect(mapStateToProps, {
  initAudienceRoom,
})(WebinarAudienceRoomContainerComponent)
